import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { BiSupport } from "react-icons/bi";
import useHttp from "hooks/use-http";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import PlaceIcon from "@mui/icons-material/Place";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { Link } from "react-router-dom";
import { StyledMenuItem, StyledPaper, StyledListItemText } from "./Menu.style";
import { getStatusRequest } from "api/requests";
import { useNavigate } from "react-router-dom";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import useAuth from "hooks/use-auth";
import { Badge } from "@mui/material";

export default function MenuCM(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const authCTX = useAuth();
  const currentPath = location.pathname.split()[0];

  const signOutAccount = () => {
    authCTX.logout();
    navigate("/");
  };

  const { request } = useHttp();

  const [messageCount, setMessageCount] = useState(0);
  const [ticketCount, setTicketCount] = useState(0);

  const getStatus = useCallback(async () => {
    const res = await request({
      url: getStatusRequest,
    });
    setMessageCount(res.unseen_notifications_count);
    setTicketCount(res.new_tickets_count);
  }, [request]);

  useEffect(() => {
    if (authCTX.isLoggedIn) {
      getStatus();
    }
  }, []);

  const ListItems = [
    {
      label: "اطلاعات حساب",
      icon: <PersonIcon fontSize="small" />,
      url: "/profile",
    },
    {
      label: "آدرس های من",
      icon: <PlaceIcon fontSize="small" />,
      url: "/address",
    },
    {
      label: "سفارشات",
      icon: <ShoppingBagIcon fontSize="small" />,
      url: "/orders",
    },
    {
      label: "پیام های من",
      icon:
        messageCount !== "0" ? (
          <Badge color="warning" badgeContent={messageCount}>
            <MailIcon fontSize="small" />
          </Badge>
        ) : (
          <Badge color="warning">
            <MailIcon fontSize="small" />
          </Badge>
        ),

      url: "/message",
    },
    {
      label: "پشتیبانی",
      icon:
        ticketCount !== "0" ? (
          <Badge color="warning" badgeContent={ticketCount}>
            <BiSupport />
          </Badge>
        ) : (
          <Badge color="warning">
            <BiSupport />
          </Badge>
        ),

      url: "/ticket",
    },
  ];

  return (
    <StyledPaper sx={{ width: "100%" }}>
      <MenuList>
        {ListItems.map((item) => (
          <StyledMenuItem $isActive={item.url === currentPath} key={item.label}>
            <Link to={item.url}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText>{item.label}</ListItemText>
            </Link>
          </StyledMenuItem>
        ))}

        <Divider />
        <StyledMenuItem
          onClick={signOutAccount}
          style={{
            paddingTop: "11px",
            paddingBottom: "11px",
            // paddingRight: "14px !important",
            // background: "#dc0000",
            color: "#dc0000",
          }}
        >
          <ListItemIcon style={{ marginRight: "11px" }}>
            <PowerSettingsNewIcon
              fontSize="small"
              style={{ color: "#dc0000" }}
            />
          </ListItemIcon>
          <StyledListItemText>خروج از حساب</StyledListItemText>
        </StyledMenuItem>
      </MenuList>
    </StyledPaper>
  );
}
